
'use strict';

require('es6-promise-promise');
require('whatwg-fetch');

const $ = require('jquery');

function objectValues(obj)
{
    var res = [];
    for (var i in obj)
    {
        if (obj.hasOwnProperty(i))
        {
            res.push(obj[i]);
        }
    }
    return res;
}

module.exports = ($oElem, p_sQuestionnaireTitle, p_iCurrent,p_sLanguage, p_iTotal) => (question) =>
{
    return new Promise( function (resolve, reject) {

        const questionValue = objectValues(question)[0] ;
        $('#nvtButton').hide() ;
        if(questionValue.options){
            if(questionValue.options.type='nvtButton'){
                $('#nvtButton').attr('data-score', questionValue.options.value).attr('data-answerid', '0').show() ;
                if(p_sLanguage == 'EN'){
                    $('#nvtButton').html('<span>Not applicable</span>');
                }
            }

        }

        var sTitle = p_sQuestionnaireTitle ;
        if(p_sQuestionnaireTitle != 'Instaptest' && p_sQuestionnaireTitle != 'Introductory Test'){
           sTitle = sTitle + ' - ' + questionValue.sectionLabel ;
        }

        let sQuestionText = 'Vraag '+(p_iCurrent+1)+ ' van '+ p_iTotal ;
        if(p_sLanguage == 'EN'){
            sQuestionText = 'Question '+(p_iCurrent+1)+ ' of '+ p_iTotal ;
        }


        const oQuestion = {questionnaioreTitle:sTitle, question:questionValue,progress:(100/p_iTotal*(p_iCurrent+1)),questionText:sQuestionText};
        const template = require('./templates/question.hbs');
        const html = template(oQuestion) ;

        $oElem.html(html) ;

        resolve();

    });

}
